import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';

import AntSearchPivotGrid from './AntSearchPivotGrid';
import AntToolbar from './AntToolbar';
import AntWidgetSkeleton from './AntWidgetSkeleton';
import useWidgetFirstLoad from './AntWidgetSkeleton/useWidgetFirstLoad';

export default function (props) {
    const [loaded, markLoaded] = useWidgetFirstLoad(Boolean(props.url || props.table || props.loadFunc));

    let storageKey = props.storageKey
        ? props.storageKey
        : 'widget-pivot-grid-' +
          (props.name ? props.name : props.entityName ? props.entityName : props.API && props.API.entityName ? props.API.entityName : '');

    const grid = useRef();

    return (
        <React.Fragment>
            {props.showTitle !== false && (
                <AntToolbar
                    title={props.title ? props.title : props.API && props.API.entityDisplay ? props.API.entityDisplay : props.entityDisplay}
                    showHelp={props.showHelp}
                    isH6={true}
                    upperCase={true}
                    // upperCase={props.upperCase}
                />
            )}

            <div className="ant-widget-skeleton-host">
                    {!loaded && <AntWidgetSkeleton variant="pivot" overlay={true} height={props.height} rows={6} />}
                    <AntSearchPivotGrid
                    ref={grid}
                    storageKey={storageKey}
                    chart={props.chart}
                    showChart={props.showChart}
                    API={props.API}
                    table={props.table}
                    url={props.url}
                    entityName={props.API.entityName ? props.API.entityName : props.entityName}
                    entityDisplay={props.API.entityDisplay ? props.API.entityDisplay : props.entityDisplay}
                    loadFunc={props.loadFunc}
                    searchConditions={props.searchConditions}
                    searchFields={props.searchFields}
                    showDownload={props.pivotGrid.showDownload}
                    showActionBar={props.pivotGrid.showActionBar}
                    showSearchBar={props.pivotGrid.showSearchBar}
                    autoFocusSearchBar={props.autoFocusSearchBar}
                    fields={props.fields}
                    actionItems={props.actionItems}
                    configFields={props.configFields}
                    queryFields={props.queryFields}
                    options={props.options}
                    onCellPrepared={props.onCellPrepared}
                    showColumnTotals={props.showColumnTotals}
                    showColumnGrandTotals={props.showColumnGrandTotals}
                    showRowTotals={props.showRowTotals}
                    showRowGrandTotals={props.showRowGrandTotals}
                    isMonthlyReport={props.isMonthlyReport}
                    isCurrency={props.isCurrency}
                    onLoaded={markLoaded}
                    />
            </div>
        </React.Fragment>
    );
}
